"use strict";

exports.__esModule = true;
exports.TimeEditor = exports.EDITOR_TYPE = void 0;
var _timeEditor = require("./timeEditor");
exports.EDITOR_TYPE = _timeEditor.EDITOR_TYPE;
exports.TimeEditor = _timeEditor.TimeEditor;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/timeEditor/index.js
// module id = 451
// module chunks = 0